import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { observer } from 'mobx-react-lite';
import PlaceholderDate from '@nedoShared/modules/notes/placeholder/placeholderDate/PlaceholderDate';
import PlaceholderResource from '@nedoShared/modules/notes/placeholder/placeholderResource/PlaceholderResource';
import PlaceholderSelect from '@nedoShared/modules/notes/placeholder/placeholderSelect/PlaceholderSelect';
import PlaceholderText from '@nedoShared/modules/notes/placeholder/placeholderText/PlaceholderText';
const Placeholder = (props) => {
    var _a;
    const type = (_a = props.data) === null || _a === void 0 ? void 0 : _a.type;
    switch (type) {
        case 'text':
            return (_jsx(PlaceholderText, Object.assign({}, props)));
        case 'resource':
            return (_jsx(PlaceholderResource, Object.assign({}, props)));
        case 'date':
            return (_jsx(PlaceholderDate, Object.assign({}, props)));
        case 'select':
            return (_jsx(PlaceholderSelect, Object.assign({}, props)));
        default:
            return null;
    }
};
export default observer(Placeholder);
